import React, { Suspense, lazy, useState } from 'react';

import { NavLink } from 'react-router-dom';
import routes from '../../data/routes';

const Menu = lazy(() => import('react-burger-menu/lib/menus/slide'));

const Hamburger = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="hamburger-container">
      <nav className="main" id="hambuger-nav">
        <ul>
          {open ? (
            <li className="menu close-menu">
              <div onClick={() => setOpen(!open)} className="menu-hover">&#10005;</div>
            </li>
          ) : (
            <li className="menu open-menu">
              <div onClick={() => setOpen(!open)} className="menu-hover">&#9776;</div>
            </li>
          )}
        </ul>
      </nav>
      {open && (
        <div
          className="menu-backdrop"
          role="button"
          tabIndex={0}
          aria-label="Close menu"
          onClick={() => setOpen(false)}
        />
      )}
      <Suspense fallback={<></>}>
        <Menu
          right
          noOverlay
          isOpen={open}
          onStateChange={({ isOpen }) => setOpen(isOpen)}
        >
          <ul className="hamburger-ul">
            {routes.map((l) => (
              <li key={l.label}>
                <NavLink to={l.path} end onClick={() => setOpen(false)}>
                  <h3 className={l.index ? 'index-li' : undefined}>{l.label}</h3>
                </NavLink>
              </li>
            ))}
          </ul>
        </Menu>
      </Suspense>
    </div>
  );
};

export default Hamburger;
